import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

const { userVehicle, errors } = copy;

export const fields: IFormFields = [
  {
    name: "licensePlate",
    label: userVehicle.fields.licensePlate,
    type: IFieldType.text,
    validation: {
      required: errors.required,
    },
    style: {
      gridColumn: "span 3",
    },
  },
  {
    name: "brand",
    label: userVehicle.fields.brand,
    type: IFieldType.text,
    style: {
      mobile: {
        gridColumn: "span 3",
      },
    },
  },
  {
    name: "model",
    label: userVehicle.fields.model,
    type: IFieldType.text,
    style: {
      mobile: {
        gridColumn: "span 3",
      },
    },
  },
  {
    name: "color",
    label: userVehicle.fields.color,
    type: IFieldType.text,
    style: {
      mobile: {
        gridColumn: "span 3",
      },
    },
  },
  {
    name: "info",
    label: userVehicle.fields.info,
    type: IFieldType.rte,
    style: {
      gridColumn: "span 3",
    },
  },
];
